/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, createContext, forwardRef } from 'react';
import { type ContextValue, Popover as PopoverCore, type PopoverProps as PopoverCoreProps, useContextProps } from 'react-aria-components';

interface PopoverProps extends Omit<PopoverCoreProps, 'style' | 'className'> {
  style?: stylex.StyleXStyles;
}

const PopoverContext = createContext<ContextValue<PopoverProps, HTMLElement>>({});

const Popover = forwardRef((props: PopoverProps, ref: ForwardedRef<HTMLElement>) => {
  [props, ref] = useContextProps(props, ref, PopoverContext);

  const { style, children, ...coreProps } = props;

  return (
    <PopoverCore
      ref={ref}
      {...stylex.props(styles.base, style)}
      {...coreProps}>
      {children}
    </PopoverCore>
  );
});

const slideInFromTop = stylex.keyframes({
  '0%': {
    opacity: 0,
    transform: 'translateY(-5px)',
  },
  '100%': {
    opacity: 1,
    transform: 'translateY(0)',
  },
});

const slideOutToTop = stylex.keyframes({
  '0%': {
    opacity: 1,
    transform: 'translateY(0)',
  },
  '100%': {
    opacity: 0,
    transform: 'translateY(-5px)',
  },
});

const slideInFromBottom = stylex.keyframes({
  '0%': {
    opacity: 0,
    transform: 'translateY(5px)',
  },
  '100%': {
    opacity: 1,
    transform: 'translateY(0)',
  },
});

const slideOutToBottom = stylex.keyframes({
  '0%': {
    opacity: 1,
    transform: 'translateY(0)',
  },
  '100%': {
    opacity: 0,
    transform: 'translateY(5px)',
  },
});

const styles = stylex.create({
  base: {
    outline: 'none',
    animationDuration: '200ms',
    animationFillMode: 'forwards',
    animationName: {
      default: null,
      ':is([data-entering])': slideInFromBottom,
      ':is([data-exiting])': slideOutToBottom,
    },
    animationTimingFunction: 'ease-out',
    boxSizing: 'border-box',
    opacity: {
      default: null,
      ':is([data-entering], [data-placement="bottom"])': slideInFromTop,
      ':is([data-entering], [data-placement="top"])': slideInFromBottom,
      ':is([data-exiting], [data-placement="bottom"])': slideOutToTop,
      ':is([data-exiting], [data-placement="top"])': slideOutToBottom,
    },
    minWidth: 'var(--trigger-width)',
  },
});

export { Popover, PopoverContext, type PopoverProps };
